<cmps-wait-status *ngIf="hasPendingData"></cmps-wait-status>
<div *ngIf="!hasPendingData && (data == null || items.length === 0)">
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<ng-container *ngIf="!hasPendingData && data != null && items.length !== 0">
    <ngb-tabset
        [activeId]="'cmpsPillarPerformanceTab' + options.pillar?.pillarID"
    >
        <ng-template
            ngFor
            let-i
            [ngForOf]="items"
        >
            <ngb-tab id="{{ 'cmpsPillarPerformanceTab' + i.id }}">
                <ng-template ngbTabTitle>{{ i.name }}</ng-template>
                <ng-template ngbTabContent>
                    <div class="table-responsive">
                        <table
                            class="table table-striped table-sm table-bordered cmps-widget-table"
                        >
                            <thead class="thead-light">
                                <tr>
                                    <th>{{ i18n._53_NAME | translate }}</th>
                                    <th>
                                        {{ i18n._67_SUPERGROUP | translate }}
                                    </th>
                                    <th
                                        class="value"
                                        *ngFor="let j of i.metrics"
                                    >
                                        {{ j.name }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container
                                    *ngIf="
                                        i.users != null && i.users.length !== 0
                                    "
                                >
                                    <ng-container
                                        *ngTemplateOutlet="
                                            row;
                                            context: {
                                                i: i,
                                                j: i.users[0],
                                                jj: 0
                                            }
                                        "
                                    ></ng-container>
                                </ng-container>
                                <ng-container *ngIf="i.overall">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            row;
                                            context: {
                                                i: i,
                                                j: i.overall,
                                                jj: -1
                                            }
                                        "
                                    ></ng-container>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                    <div class="table-responsive">
                        <table
                            class="table table-striped table-sm table-bordered cmps-widget-table"
                            *ngIf="i.users != null && i.users.length > 1"
                        >
                            <thead class="thead-light">
                                <tr>
                                    <th>{{ i18n._53_NAME | translate }}</th>
                                    <th>
                                        {{ i18n._67_SUPERGROUP | translate }}
                                    </th>
                                    <th
                                        class="value"
                                        *ngFor="let j of i.metrics"
                                    >
                                        {{ j.name }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-template
                                    ngFor
                                    let-j
                                    let-jj="index"
                                    [ngForOf]="i.users"
                                >
                                    <ng-container *ngIf="jj > 0">
                                        <ng-container
                                            *ngTemplateOutlet="
                                                row;
                                                context: { i: i, j: j, jj: jj }
                                            "
                                        ></ng-container>
                                    </ng-container>
                                </ng-template>
                            </tbody>
                        </table>
                    </div>
                </ng-template>
            </ngb-tab>
        </ng-template>
    </ngb-tabset>
</ng-container>

<ng-template
    let-i="i"
    let-j="j"
    let-jj="jj"
    #row
>
    <tr>
        <td class="text-nowrap">{{ j.username }}</td>
        <td class="text-nowrap">{{ j.superGroupName }}</td>
        <td
            class="text-nowrap value"
            *ngFor="let k of i.metrics; let kk = index"
        >
            <span
                [ngStyle]="{ color: j.values[kk].thresholdColor }"
                [ngClass]="{
                    bold:
                        j.values[kk].thresholdColor != null &&
                        j.values[kk].thresholdColor.length !== 0 &&
                        j.values[kk].thresholdColor.toLowerCase() !== 'black' &&
                        !j.values[kk].thresholdColor.startsWith('#000')
                }"
            >
                {{
                    j.values[kk].actual == null
                        ? '-'
                        : (j.values[kk].actual | cmpsNumber: '1.1-1')
                }}
            </span>
            <cmps-icon
                [style.fill]="
                    j.values[kk].trendClass.split(' ')[0].toLowerCase()
                "
                [svgIcon]="j.values[kk].trendClass.split(' ')[1].toLowerCase()"
                *ngIf="j.values[kk].trendClass?.split(' ')?.length > 1"
            ></cmps-icon>
        </td>
    </tr>
</ng-template>
